(function () {
  'use strict';
  if (window.KCPP) return;
  var doc = document;
  function $(s, r) { return (r || doc).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); }
  var fmt;
  function money(n) {
    if (!fmt) {
      try { fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }); }
      catch (e) { fmt = { format: function (v) { return '$' + v.toFixed(2); } }; }
    }
    return fmt.format(n);
  }
  function fill(text, map) {
    return String(text || '').replace(/\[(\w+)\]/g, function (all, k) { return k in map ? map[k] : all; });
  }
  function once(el) {
    if (el.__kpp) return false;
    el.__kpp = true;
    return true;
  }
  function seg(root, onChange) {
    if (!root) return;
    $$('button', root).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('button', root).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        onChange(b);
      });
    });
  }

  function tabs(root) {
    var list = $$('[role="tab"]', root);
    function show(t, focus) {
      list.forEach(function (x) {
        var on = x === t;
        x.setAttribute('aria-selected', String(on));
        x.tabIndex = on ? 0 : -1;
        var panel = doc.getElementById(x.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) t.focus();
    }
    list.forEach(function (t, i) {
      t.addEventListener('click', function () { show(t); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : e.key === 'ArrowUp' || e.key === 'ArrowLeft' ? -1 : 0;
        if (e.key === 'Home') { e.preventDefault(); show(list[0], true); return; }
        if (e.key === 'End') { e.preventDefault(); show(list[list.length - 1], true); return; }
        if (!d) return;
        e.preventDefault();
        show(list[(i + d + list.length) % list.length], true);
      });
    });
    root.__show = function (i) { if (list[i]) show(list[i]); };
  }

  function retail(rc) {
    var T = function (k) { return rc.getAttribute('data-t-' + k) || ''; };
    var W = parseFloat(rc.getAttribute('data-wholesale')) || 0;
    var st = { price: parseFloat(rc.getAttribute('data-price')) || 0, pack: parseInt(rc.getAttribute('data-pack'), 10) || 4, week: parseInt(rc.getAttribute('data-week'), 10) || 0 };
    var custom = $('[data-custom]', rc), wk = $('[data-in="week"]', rc);
    function out(k, v) { var e = $('[data-o="' + k + '"]', rc); if (e) e.textContent = v; }
    function paint() {
      var kept = st.price - W;
      var cover = st.price > 0 ? Math.ceil((W * st.pack) / st.price - 1e-9) : 0;
      var weeks = st.week > 0 ? Math.ceil(st.pack / st.week) : 0;
      out('kept', money(Math.max(0, kept)));
      out('margin', st.price > 0 ? Math.max(0, Math.round((kept / st.price) * 1000) / 10) + '%' : '0%');
      out('cost', money(W * st.pack));
      out('cover', kept > 0 ? cover + ' / ' + st.pack : T('raise'));
      out('all', money(Math.max(0, kept) * st.pack));
      out('weeks', st.week > 0 ? (weeks === 1 ? T('week') : fill(T('weeks'), { n: weeks })) : T('norate'));
      out('week', st.week === 1 ? T('unit') : fill(T('units'), { n: st.week }));
      out('month', money(Math.max(0, kept) * st.week * 52 / 12));
      var dots = $('[data-o="dots"]', rc);
      if (dots) {
        dots.innerHTML = '';
        for (var i = 0; i < st.pack; i++) { var d = doc.createElement('i'); if (kept > 0 && i < cover) d.className = 'on'; dots.appendChild(d); }
      }
      out('dotcap', kept > 0 ? fill(T('cover'), { n: cover, price: money(st.price), pack: st.pack }) : T('under'));
    }
    seg($('[data-seg="price"]', rc), function (b) { st.price = parseFloat(b.getAttribute('data-v')) || 0; if (custom) custom.value = st.price.toFixed(2); paint(); });
    seg($('[data-seg="pack"]', rc), function (b) { st.pack = parseInt(b.getAttribute('data-v'), 10) || 4; paint(); });
    if (custom) {
      custom.addEventListener('input', function () {
        var v = parseFloat(custom.value);
        if (!(v >= 0)) return;
        st.price = Math.min(500, v);
        $$('[data-seg="price"] button', rc).forEach(function (x) { x.setAttribute('aria-pressed', String(Math.abs(parseFloat(x.getAttribute('data-v')) - st.price) < 0.001)); });
        paint();
      });
      custom.addEventListener('change', function () { var v = parseFloat(custom.value); if (!(v >= 0)) v = st.price; custom.value = Math.min(500, v).toFixed(2); });
    }
    if (wk) wk.addEventListener('input', function () { st.week = parseInt(wk.value, 10) || 0; paint(); });
    paint();
  }

  function session(bc) {
    var T = function (k) { return bc.getAttribute('data-t-' + k) || ''; };
    var sizeBtns = $$('[data-seg="size"] button', bc);
    var b = { size: sizeBtns[0], ml: parseFloat(bc.getAttribute('data-ml')) || 5, week: parseInt(bc.getAttribute('data-week'), 10) || 0 };
    var mlIn = $('[data-in="ml"]', bc), wkIn = $('[data-in="sessions"]', bc);
    function out(k, v) { var e = $('[data-o="' + k + '"]', bc); if (e) e.textContent = v; }
    function paint() {
      if (!b.size) return;
      var price = parseFloat(b.size.getAttribute('data-price')) || 0;
      var vol = parseFloat(b.size.getAttribute('data-vol')) || 1;
      var name = b.size.getAttribute('data-name') || '';
      var perMl = price / vol;
      var per = perMl * b.ml;
      var month = b.ml * b.week * 52 / 12;
      out('per', money(per));
      out('ml', b.ml + ' mL');
      out('wk', b.week);
      out('permlx', fill(T('perml'), { price: money(perMl) }));
      out('sessions', fill(T('about'), { n: Math.floor(vol / b.ml) }));
      out('bottles', b.week > 0 ? (Math.round((month / vol) * 10) / 10) + ' × ' + name : T('norate'));
      out('monthcost', money(per * b.week * 52 / 12));
      out('sizecap', name + ' · ' + money(price) + ' · ' + vol + ' mL');
    }
    seg($('[data-seg="size"]', bc), function (x) { b.size = x; paint(); });
    seg($('[data-seg="start"]', bc), function (x) { b.ml = parseFloat(x.getAttribute('data-v')) || 1; if (mlIn) mlIn.value = b.ml; paint(); });
    if (mlIn) mlIn.addEventListener('input', function () {
      b.ml = parseFloat(mlIn.value) || 1;
      $$('[data-seg="start"] button', bc).forEach(function (x) { x.setAttribute('aria-pressed', String(parseFloat(x.getAttribute('data-v')) === b.ml)); });
      paint();
    });
    if (wkIn) wkIn.addEventListener('input', function () { b.week = parseInt(wkIn.value, 10) || 0; paint(); });
    paint();
  }

  function matcher(root) {
    var panels = $$('[data-panel]', root);
    var q = $('.kpp-match__q', root);
    seg(q, function (x) {
      var i = parseInt(x.getAttribute('data-v'), 10) || 0;
      panels.forEach(function (p, n) { p.hidden = n !== i; });
    });
    root.__show = function (i) {
      var btn = $$('button', q)[i];
      if (btn) btn.click();
    };
  }

  function init(scope) {
    $$('[data-kpp-tabs]', scope).forEach(function (r) { if (once(r)) tabs(r); });
    $$('[data-kpp-calc="retail"]', scope).forEach(function (r) { if (once(r)) retail(r); });
    $$('[data-kpp-calc="session"]', scope).forEach(function (r) { if (once(r)) session(r); });
    $$('[data-kpp-match]', scope).forEach(function (r) { if (once(r)) matcher(r); });
  }

  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
  doc.addEventListener('shopify:block:select', function (e) {
    var t = e.target;
    var tab = t.closest && t.closest('[role="tab"]');
    var root = tab && tab.closest('[data-kpp-tabs]');
    if (root && root.__show) root.__show($$('[role="tab"]', root).indexOf(tab));
    var mb = t.closest && t.closest('.kpp-match__q button');
    var mr = mb && mb.closest('[data-kpp-match]');
    if (mr && mr.__show) mr.__show(parseInt(mb.getAttribute('data-v'), 10) || 0);
  });
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(doc); });
  else init(doc);
  window.KCPP = { init: init };
})();
